"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _circularChart = _interopRequireDefault(require("./circular-chart.css"));
var CircularChart = function CircularChart(_ref) {
  var className = _ref.className,
    total = _ref.total;
  var percentage = total / 10 * 100;
  var percentageInDegrees = percentage / 100 * 360 / 2;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(_circularChart["default"].circularChartContainer, className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _circularChart["default"].circularChartInner
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _circularChart["default"].circularChartFill,
    style: {
      transform: "rotate(" + percentageInDegrees + "deg)"
    }
  })));
};
CircularChart.displayName = 'CircularChart';
var _default = exports["default"] = CircularChart;